import { format, addMinutes } from "date-fns";

export const DateHelper = {
  GetDifferenceOfDaysFromToday,
  ToLocaleDateString,
  ProcessDate,
  DateFromToday,
  DateVisibility,
  ToUTCDateTime,
  IncrementDate,
  ToFormattedDate,
  ToFormattedGMTDate,
  GetCurrentDate,
  GetDate
};

function GetCurrentDate() {
  return GetDate(new Date())
}

function GetDate(date) {
  let currentDate = new Date(date)
  currentDate.setHours(0, 0, 0, 0);
  return currentDate
}

function GetDifferenceOfDaysFromToday(date) {
  const _MS_PER_DAY = 1000 * 60 * 60 * 24;

  var today = new Date();
  var inputDate = new Date(date);
  const utc1 = Date.UTC(
    inputDate.getFullYear(),
    inputDate.getMonth(),
    inputDate.getDate()
  );
  const utc2 = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());

  return Math.floor((utc2 - utc1) / _MS_PER_DAY);
}

function ToLocaleDateString(dateStr) {
  if (dateStr === null || dateStr === "" || dateStr === undefined) return "N/A";
  var date = new Date(dateStr);
  return date.toLocaleDateString();
}

function ToFormattedDate(dateStr, pattern = "dd MMM yyyy") {
  if (dateStr === null || dateStr === "" || dateStr === undefined) return "N/A";
  var date = new Date(dateStr);
  return format(date, pattern);
}

function ToFormattedGMTDate(dateStr, pattern = "dd MMM yyyy") {
  if (dateStr === null || dateStr === "" || dateStr === undefined) return "N/A";
  var date = new Date(dateStr);
  //console.log('date: ', dateStr);
  //console.log('date.getTimezoneOffset(): ', date.getTimezoneOffset());
  //console.log('addMinutes(date, date.getTimezoneOffset()): ', addMinutes(date, date.getTimezoneOffset()));
  //console.log('formatted: ', format(addMinutes(date, date.getTimezoneOffset()), pattern));
  return format(addMinutes(date, date.getTimezoneOffset()), pattern);
}

function ProcessDate(dateInfo) {
  if (dateInfo) {
    var dateString = dateInfo.toString();
    dateString = dateString.split(" ").slice(1, 4).join("-");
    return dateString;
  } else {
    return null;
  }
}

function DateFromToday(dateStr) {
  if (
    new Date(dateStr).setHours(0, 0, 0, 0) >= new Date().setHours(0, 0, 0, 0)
  ) {
    return true;
  } else {
    return false;
  }
}

function DateVisibility(dateStr) {
  if (
    new Date(dateStr).setHours(0, 0, 0, 0) != new Date(0).setHours(0, 0, 0, 0)
  ) {
    return true;
  } else {
    return false;
  }
}

function ToUTCDateTime(localDate) {
  if (localDate == null) {
    return "";
  }
  return new Date(
    localDate.getTime() - localDate.getTimezoneOffset() * 60000
  ).toISOString();
}

function IncrementDate(
  date,
  daysToIncrement,
  toFormatted = false,
  format = "dd MMM yyyy",
  toUtcDateString = false
) {
  var dateObj = new Date(date);
  dateObj.setDate(dateObj.getDate() + daysToIncrement);

  if (toFormatted) {
    return ToFormattedDate(dateObj, format);
  }

  if (toUtcDateString) {
    return ToUTCDateTime(dateObj);
  }

  return ToLocaleDateString(dateObj);
}
